import styled from 'styled-components';

export const ArticleDetailSection = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid hsl(0deg, 0%, 0%, 10%);

  @media (max-width: 720px) {
    padding: 16px 12px;
  }

  h1 {
    font-size: clamp(20px, 3vw, 24px);
    color: #000;
    padding: 14px 0;
    line-height: 1.4;
  }

  img {
    width: 22px;
    height: 22px;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: ${(props) => props.height};
`;

export const Tag = styled.p`
  text-transform: uppercase;
  font-size: clamp(12px, 2vw, 14px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
`;

export const Views = styled.span`
  font-size: 12px;
  color: hsl(0deg, 0%, 0%, 60%);
  padding-left: 6px;
`;

export const WrittenDate = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 38%);
`;
